module.exports = __webpack_public_path__ + "static/media/40-13.1f8dff85.mp3";